import { api } from './api';

export const aiReportsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAiReportsConfig: builder.query({
      query: () => ({
        url: 'getAiReportsConfig',
        method: 'GET',
      }),
    }),
    verifyAiReportsAccessCode: builder.mutation({
      query: ({ accessCode }) => ({
        url: 'verifyAiReportsAccessCode',
        method: 'POST',
        body: { accessCode },
      }),
    }),
    getAiReports: builder.mutation({
      query: () => ({
        url: 'getAiReports',
        method: 'POST',
        body: {},
      }),
    }),
    getAiReport: builder.mutation({
      query: ({ reportId }) => ({
        url: 'getAiReport',
        method: 'POST',
        body: { reportId },
      }),
    }),
    deleteAiReport: builder.mutation({
      query: ({ reportId }) => ({
        url: 'deleteAiReport',
        method: 'POST',
        body: { reportId },
      }),
    }),
  }),
});

export const {
  useGetAiReportsConfigQuery,
  useVerifyAiReportsAccessCodeMutation,
  useGetAiReportsMutation,
  useGetAiReportMutation,
  useDeleteAiReportMutation,
} = aiReportsApi;
